import filterObjectProperties from "../../__internal__/filter-object-properties";
export const gridPropertyNames = ["gridColumn", "gridRow", "gridArea", "gridAutoFlow", "gridAutoRows", "gridAutoColumns", "gridTemplateRows", "gridTemplateColumns", "gridTemplateAreas"];
export default function filterStyledSystemGridProps(originalObject) {
  return filterObjectProperties(originalObject, gridPropertyNames);
}